import React, { useState } from 'react'
import { message } from 'antd'

const QuoteForm = ({OriginalAddress , OnSubmit}) => {
    const [Fname, setFname] = useState('')
    const [Lname, setLname] = useState('')
    const [Email, setEmail] = useState('')
    const [Phone, setPhone] = useState('')
    const [Address, setAddress] = useState('')

    const FormSubmit = {
        fName : Fname,
        lName : Lname,
        email : Email,
        phone : Phone,
        address: Address
    }

    const onFormSubmit = () => {
        if(Fname === '' || Lname === '' || Email === '' || Phone === ''){
            message.error('Fill All the Fields')
            setFname('')
            setLname('')
            setEmail('')
            setPhone('')
        }else{
            OnSubmit(FormSubmit)
            setFname('')
            setLname('')
            setEmail('')
            setPhone('')
        }
    }

    return (
        <div className='Quote-Form'>
            <div className='Section-1'>
                <div className='input-1'>
                    <h6>First Name</h6>
                    <input value={Fname} onChange={e=> setFname(e.target.value)} className='Input' placeholder='First Name' />
                </div>
                <div className='input-2'>
                    <h6>Last Name</h6>
                    <input value={Lname} onChange={e=> setLname(e.target.value)} className='Input' placeholder='Last Name' />
                </div>
            </div>
            <div className='input-div'>
                <h6>Email</h6>
                <input value={Email} onChange={e=> setEmail(e.target.value)} className='Input' placeholder='ex : youremail@gmail.com' />
            </div>
            <div className='input-div'>
                <h6>Phone #</h6>
                <input value={Phone} onChange={e=> setPhone(e.target.value)} className='Input' placeholder='ex : +4321098765' />
            </div>
            {OriginalAddress ? (
                <div className='input-div'>
                <h6>{OriginalAddress}</h6>
                <input value={Address} onChange={e => setAddress(e.target.value)} className='Input' placeholder={OriginalAddress} />
            </div>
            ) : <></>}
            <button className='Secondary-btn Button' onClick={onFormSubmit}>SUBMIT</button>
            
        </div>
    )
}

export default QuoteForm
